$(function(){
  let buttonEls = $('[data-multichecker-button]');
  let itemsEls  = $('[data-multichecker-items]');

  // show on click 
  buttonEls.on('click', function(){
    let thisEl      = $(this);
    let containerEl = thisEl.closest('[data-multichecker]');
    let itemsEl     = containerEl.find('[data-multichecker-items]');
    
    // make active
    containerEl.toggleClass('active');
  });

  // hide on click
  $(document).on('click', function(e){
    let targetEl = $(e.target);
    let multicheckerEl;

    // get multichecker parent
    if(targetEl.parents('[data-multichecker]').length) multicheckerEl = targetEl.closest('[data-multichecker]'); 
    if(targetEl.is('[data-multichecker]')) multicheckerEl = targetEl;

    // else hide multicheckers
    $('[data-multichecker]').not(multicheckerEl).removeClass('active');
  });

  // prevent body scroll inside items list
  let currentScrollEl = false;

  window.addEventListener('mousewheel', function(e) { 
    if(currentScrollEl) e.preventDefault();
  }, { passive: false });

  itemsEls.on('mouseenter', function() { currentScrollEl = this; });
  itemsEls.on('mouseleave', function() { currentScrollEl = false; });


  // on change change select text
  let inputEls = itemsEls.find('input');
  inputEls.on('change', function(){
    let thisEl      = $(this);
    let containerEl = thisEl.closest('[data-multichecker]');
    let checkedEls  = containerEl.find('input:checked');
    let selectEl    = containerEl.find('[data-multichecker-button]');
    let text        = '';
    
    // get text
    if(!containerEl.attr('data-text')) containerEl.attr('data-text', selectEl.html());
    text = containerEl.attr('data-text');

    // set text and count of checked inputs
    if(checkedEls.length) {
      selectEl.html(text + ': ' + checkedEls.length);
    }
    else {
      selectEl.html(text);
    }
  });
});